module.exports = __webpack_public_path__ + "img/bottom-left-arrow.037845e.svg";